webpackJsonp([35783957827783],{

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/happy-kid-picture-mobile.0dae597f.jpg";

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/happy-kid-picture.e807e7f0.jpg";

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.homePageQuery = exports.HomePageTemplate = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(18);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _Content = __webpack_require__(31);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _happyKidPicture = __webpack_require__(72);
	
	var _happyKidPicture2 = _interopRequireDefault(_happyKidPicture);
	
	var _happyKidPictureMobile = __webpack_require__(71);
	
	var _happyKidPictureMobile2 = _interopRequireDefault(_happyKidPictureMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomePageTemplate = exports.HomePageTemplate = function HomePageTemplate(_ref) {
	  var title = _ref.title,
	      content = _ref.content,
	      contentComponent = _ref.contentComponent,
	      intro = _ref.intro;
	
	  var PageContent = contentComponent || _Content2.default;
	  var backgroundCss = {
	    backgroundImage: 'url(' + _happyKidPicture2.default + ')'
	  },
	      backgroundCssMobile = {
	    backgroundImage: 'url(' + _happyKidPictureMobile2.default + ')'
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'header',
	      { id: 'about-header' },
	      _react2.default.createElement(
	        'div',
	        { className: 'Hero Hero--about' },
	        _react2.default.createElement('div', {
	          className: 'Hero-background show-for-medium',
	          style: backgroundCss
	        }),
	        _react2.default.createElement('div', {
	          className: 'Hero-background hide-for-medium',
	          style: backgroundCssMobile
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'text-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-10 is-offset-1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'section' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                title
	              ),
	              _react2.default.createElement(PageContent, { className: 'content', content: intro }),
	              _react2.default.createElement(PageContent, { className: 'content', content: content })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = function (_ref2) {
	  var data = _ref2.data;
	  var posts = data.allMarkdownRemark.edges;
	  //-- @hardcoded: this matches the placement exactly
	
	  var intro = posts.filter(function (post) {
	    return post.node.frontmatter.placement === 1;
	  })[0];
	  var homePage = posts.filter(function (post) {
	    return post.node.frontmatter.placement === 2;
	  })[0];
	
	  return _react2.default.createElement(HomePageTemplate, {
	    contentComponent: _Content.HTMLContent,
	    title: homePage.node.frontmatter.title,
	    content: homePage.node.html,
	    intro: intro.node.html
	  });
	};
	
	var homePageQuery = exports.homePageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-fb9b4b042ddaf98ff616.js